import {
	allowed,
	allowedInAmTeam,
	allowedInBeta,
	api,
	appData,
	arrayIt,
	arraySetter,
	cookies,
	env,
	events,
	getApiKey,
	hasProp,
	mapTo,
	numbers,
	objects,
	queryArgs,
	requests,
	ruleHelpers,
	storage,
} from 'optinmonster-js-library/src/utils';
import { bulkWatchHandler, getAppData, siteId, siteIds, sort } from 'optinmonster-js-library/src/vue/utils';
import findDiffPosition from './findDiffPosition';
import hasAuthError from './hasAuthError';
import isNoCampaignsError from './isNoCampaignsError';
import * as debug from './debug';
import * as strings from './strings';
import * as dates from './dates';
import urls from './urls';
import { disableDevCookie } from 'optinmonster-js-library/src/utils/apiKey';

disableDevCookie();

export {
	allowed,
	allowedInAmTeam,
	allowedInBeta,
	api,
	appData,
	arrayIt,
	arraySetter,
	bulkWatchHandler,
	cookies,
	dates,
	debug,
	env,
	events,
	findDiffPosition,
	getApiKey,
	getAppData,
	hasAuthError,
	hasProp,
	isNoCampaignsError,
	mapTo,
	numbers,
	objects,
	queryArgs,
	requests,
	ruleHelpers,
	siteId,
	siteIds,
	strings,
	sort,
	storage,
	urls,
};
